import { ObrasScreen } from "@/screens/obras/obras-lista";

/** Thin wrapper — toda lógica fica em screens/obras/obras-lista */
export function ObrasListaPage() {
  return <ObrasScreen />;
}
